export default "__VITE_ASSET__DjOcWg4H__"